import { render, staticRenderFns } from "./WorkFloTaskForm.vue?vue&type=template&id=262027bc&"
import script from "./WorkFloTaskForm.vue?vue&type=script&lang=js&"
export * from "./WorkFloTaskForm.vue?vue&type=script&lang=js&"
import style0 from "./WorkFloTaskForm.vue?vue&type=style&index=0&id=262027bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports